import React from 'react';

const StatusBadge = ({ status }) => {
  const key = (status || '').toString().toLowerCase();
  const klass = {
    pending: 'mi-badge-pending',
    confirmed: 'mi-badge-confirmed',
    rescheduled: 'mi-badge-rescheduled',
    completed: 'mi-badge-completed',
    cancelled: 'mi-badge-cancelled',
    canceled: 'mi-badge-cancelled',
    active: 'mi-badge-active',
    inactive: 'mi-badge-inactive',
    open: 'mi-badge-active',
    booked: 'mi-badge-confirmed',
    // Payment statuses — keep "Completed" interview semantics (blue) but
    // surface payment success / failure with green / red.
    succeeded: 'mi-badge-success',
    paid: 'mi-badge-success',
    success: 'mi-badge-success',
    failed: 'mi-badge-failed',
    refunded: 'mi-badge-inactive',
  }[key] || 'mi-badge-default';

  return <span className={`mi-badge ${klass}`}>{status || '—'}</span>;
};

export default StatusBadge;
